import React from 'react';

import { PhotoAlbumLayout } from '^/components/molecules/PhotoAlbumLayout';
import { LayerGroupZIndex } from '^/constants/zindex';

//TOOD: Add component from here like photo viewer
const PhotoPage = () => <PhotoAlbumLayout zIndex={LayerGroupZIndex.SLIDER_MAP} />;

export default PhotoPage;
